<template>
  <!-- <nav>
    <router-link to="/"></router-link>
    <router-link to="/about"></router-link>
  </nav> -->
  <router-view/>
</template>

<script setup>
import { onMounted } from 'vue'
import { getHost } from '@/utils/domain.js'

onMounted(() => {
  getHost()
})
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
